<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "DAT_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
    
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton >
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-outline-success">
                <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>      
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO --> 
    
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit> 
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]    ="DAT_AG_GRID.id" 
                        [class] ="DAT_AG_GRID.class" 
                        [ngStyle]="DAT_AG_GRID.style" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
      </ag-grid-angular>
    </ng-template>
    <!-- GRILLA -->

  </div>
  
  <!-- MODAL DE CREACIÓN DE JERARQUIA Y SUBCANAL-->
  <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
  </app-lfsa-modal>
  
  <ng-template #abrirModal>
    <div class="container-fluid">
      <form [formGroup]="formulario" mat-dialog-content>
        <div class="row"> 
          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Grupo'" formControlName="idGrupoVendedor" [control]="formulario.get('idGrupoVendedor')" 
                                [comboBox]="comboCanal" [opcion]="'dscaGrupoVendedor'" [idOpcion]="'idGrupoVendedor'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>

          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione SubCanal'" formControlName="idSubCanal" [control]="formulario.get('idSubCanal')" 
                                [comboBox]="comboSubCanal" [opcion]="'dscaGrupoCanal'" [idOpcion]="'idTarCanal'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>

        </div>

        <app-lfsa-botones-formulario 
            (devolverAccion) ="acciones( $event )" 
            [formularioValido] ="formulario.invalid" 
            [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
        </app-lfsa-botones-formulario>
      </form>
    </div>
  </ng-template>
  <!-- END MODAL CREACION DE JERARQUIA--> 